import React, { Component } from 'react';
import { connect } from 'react-redux';

import {RadioGroup, Radio} from 'react-radio-group'
import { sendScript, sendLinks, noLinks } from '../actions';

const mapStateToProps = (state) => {
    return ({
        currentScript: state.convo.meta.currentScript,
        guestList: state.convo.meta.guestList
    });
}

class ScriptSegments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customScript: '',
            toPerson: '',
            selectedScript: '',
            debateTopic: '',
            articleA: '',
            articleB: ''
        }

        this.handleDebateTopic = this.handleDebateTopic.bind(this);
        this.handleArticleA = this.handleArticleA.bind(this);
        this.handleArticleB = this.handleArticleB.bind(this);
        this.handleCustomScript = this.handleCustomScript.bind(this);
        this.handlePersonChange = this.handlePersonChange.bind(this);
        this.handleSendCustom = this.handleSendCustom.bind(this);
        this.handleSelectedScript = this.handleSelectedScript.bind(this);
        this.handleSendSegment = this.handleSendSegment.bind(this);
    }

    handleDebateTopic(event) {
        this.setState({ debateTopic: event.target.value });
    }

    handleArticleA(event) {
        this.setState({ articleA: event.target.value });
    }

    handleArticleB(event) {
        this.setState({ articleB: event.target.value });
    }

    handleCustomScript(event) {
        console.log("triggered handleCustomScript");
        this.setState({ customScript: event.target.value });
    }

    handlePersonChange(event) {
        this.setState( { toPerson: event.target.value });
    }

    handleSendCustom(event) {
        console.log("triggered handleSendCustom");
        this.props.dispatch(sendScript(this.customInput.value));
    }

    handleSelectedScript(value) {
        console.log("triggered handleSelectedScript");
        this.setState({ selectedScript: value });
    }

    handleSendSegment(event) {
        console.log("triggered handleSendSegment");
        if (this.state.selectedScript == "links") {
            this.props.dispatch(sendLinks(this.state.articleA, this.state.articleB));
        } else {
            this.props.dispatch(noLinks());
            this.props.dispatch(sendScript(this.state.selectedScript));
        }
    }


    render() {
        let people = this.props.guests.slice();
        const peopleArray = people.slice();
        people.splice(people.length - 1, 0, 'and');
        let peopleString = people.toString();
        let intro = "Hi " + peopleString +"! Welcome to ChatPool, a place where you can say what you think and where you can learn about other people’s views. Here’s what you can expect today. We’ll start by getting to know each other and telling each other’s stories. Then we’ll get into the meat of the conversation and explore our differing views. You’ll have a moderator to offer advice about how to navigate this conversation. And the end, we’ll ask you to tell us how you think it went.";

        let objective = "Our goal is that you have empathy and understanding for a different viewpoint than your own. We’ll ask you to share your feelings at various points in the conversation.";

        let rules = "We ask that you please: \n1) Follow our moderator.\n2)Be respectful. No personal attacks or name calling allowed.\n3)Be curious and chill.";

        this.icebreakers = ["Do you think a hot dog is a sandwich. Please explain.",
            "Are you sunrise, daylight, twilight, or night? Please share why you picked your time of day?",
            "When you think about your family, what's the first thing that comes to mind?",
            "When you think about a good time, what's the first thing that comes to mind? Describe what happened.",
            "How did the article makes you feel in a gif?",
            "This debate is getting heated. Cool down a bit by playing the tune that best describes your emotion!",
            "We need to take a breather. What’s your favorite song to relax to?",
            "Where is your dream vacation spot? Why?"];
        
        let introduce = "Let’s get the conversation started! Please introduce yourself to the other person. Tell your occupation, something about your family and if you want, something important to you at this point in your life";

        let articleA = this.state.articleA == '' ? "[NO LINK PROVIDED]": this.state.articleA;
        let articleB = this.state.articleB == '' ? "[NO LINK PROVIDED]": this.state.articleB;
        let links = "This conversation is based on the following articles: \n1) " + articleA
            + "\n2) " + articleB;

        let debateTopic = this.state.debateTopic == '' ? "Is the solution to a more inclusive campus environment creating ethnic-themed dorms?": this.state.debateTopic;
        let topic = "Do you agree or disagree with this statement: "+ debateTopic;

        let personA, personB;
        if (this.state.toPerson == '') {
            personA = 'Person A';
            personB = 'Person B';
        } else {
            personA = this.state.toPerson;
            personB = peopleArray[0] == this.state.toPerson ? peopleArray[1] : peopleArray[0];    
        }

        this.introduction = [ intro, objective, rules, introduce, topic ];
        
        this.drivers = [ personA + ", why or why not?",
            personA + ", please tell " + personB + " a brief story about a personal experience in your life that has shaped your opinion on this issue.",
            personA + ", please respond, using facts and citations if possible ", 
            personA + ", what did you think about " + personB + "’s summary?",
            personA + ", what’s your response to hearing that story? Please paraphrase part of that story in your response",
            personA + ", please ask " + personB + " a specific, respectful question to probe more deeply on aspect of their beliefs related to their argument."];
        
        this.reflection = [ personA + ", what is one aspect of " + personB + "’s argument you don’t understand and why?",
            personA + ", put yourself in " + personB + "’s shoes. Write a couple of sentence of advice about what you would do next to promote more understanding about your side of this argument?",
            personA + ", please try to learn what emotions " + personB + " has about their side of the argument and why they feels this way.",
            personA + ", what do you think is " + personB + "'s rationale for their argument." ];

        this.thanks = (<p>Thanks {peopleString} for being part of ChatPool! Don’t forget fill out our feedback form!</p>);

        return (
            <div>
                <input placeholder="Type the debate topic here" type="text" value={this.state.debateTopic} onChange={this.handleDebateTopic} ref={(el) => this.debateInput = el}/>
                <input placeholder="Enter first article reference URL here" type="text" value={this.state.articleA} onChange={this.handleArticleA} ref={(el) => this.articleAInput = el}/>
                <input placeholder="Enter second article reference URL here" type="text" value={this.state.articleB} onChange={this.handleArticleB} ref={(el) => this.articleBInput = el}/>
                <RadioGroup name="scriptRadioGroup" selectedValue={this.state.selectedScript} onChange={this.handleSelectedScript}>
                <select value={this.state.toPerson} onChange={this.handlePersonChange}>
                    <option>Select guest</option>
                    {peopleArray.map((person, index) => (
                        <option key={index} value={person}>{person}</option>
                    ))}
                </select>
                <h2>Choose a pre-made script segment to send to this guest</h2>
                <div class="segment-box">
                    <h3>Introduction</h3>
                    <p>Please use the following prompts to set up the discussion between the two users.  In this section of the discussion, it is your goal to clarify the purpose, rules and expectations for the discussion to the two users. Please share the following prompts with the user in the order below:</p>
                    {
                        this.introduction.map((intro, index) => {
                            let iindex = 'i' + index;
                            return (
                                <label class="segments" key={iindex}>
                                    <Radio value={intro}/>{intro}
                                </label>
                            );
                        })
                    }
                    <label class="segments" key="links">
                        <Radio value="links"/>{links}
                    </label>
                </div>
                <div class="segment-box">
                    <h3>Icebreakers</h3>
                    <p>In this section of the discussion, you will guide both participants to establish a sense of commonality and affinity towards each other by walking them through a few ice breakers. We hope this part of the discussion will help participants go into the discussion with an appreciative and respectful mindset. After asking each person to introduce themselves, please use 2-3 of the prompts below to get the discussion rolling!
</p>
                    {
                        this.icebreakers.map((ice, index) => 
                            <label class="segments" key={index}>
                                <Radio value={ice}/>{ice}
                            </label>
                        )
                    }   
                </div>
                <div class="segment-box">
                    <h3>Conversation drivers</h3>
                    <p>Now you will start the discussion! Please use the prompts below to guide each participant throughout the discussion. Please make sure you remain unbiased with regards to the number of opportunities you give each user to participate and the types of questions you ask to each user. Your goal is to moderate the discussion so that it is as constructive and civilized as possible.</p>
                    {
                        this.drivers.map((d, index) => {
                            let dindex = 'd' + index;
                            return (
                                <label class="segments" key={dindex}>
                                    <Radio value={d}/>{d}
                                </label>
                            );
                        })
                    }
                </div>
                <div class="segment-box">
                    <h3>Reflection</h3>
                    <p>Great work! Give yourself a pat on the back for moderating the discussion. Here’s the most important part of the discussion: Please wrap up the discussion by asking each user to summarize each other’s opinions. Your goal is to ensure the two participants leave the debate with a clear understanding of each other’s opinions.</p>
                    {
                        this.reflection.map((r, index) => {
                            let dindex = 'r' + index;
                            return (
                                <label class="segments" key={r}>
                                    <Radio value={r}/>{r}
                                </label>
                            );
                        })
                    }
                </div>
                </RadioGroup>
                <button onClick={this.handleSendSegment}>Send script segment to {this.state.toPerson}</button>
                <h2>Or, send this guest a customized script segment</h2>
                <input placeholder="Type your custom script here" type="text" name="customScript" value={this.state.customScript} onChange={this.handleCustomScript} ref={(el) => this.customInput = el}/>
                <button onClick={this.handleSendCustom}>Send custom script</button>
            </div>
        );
    }
}
export default connect(mapStateToProps)(ScriptSegments);


// WEBPACK FOOTER //
// ./src/components/ScriptSegments.js